/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

require('./bootstrap')

/*Toggle dropdown list*/
/*https://gist.github.com/slavapas/593e8e50cf4cc16ac972afcbad4f70c8*/

var userMenuDiv = document.getElementById('userMenu')
var userMenu = document.getElementById('userButton')

var navMenuDiv = document.getElementById('nav-content')
var navMenu = document.getElementById('nav-toggle')

document.onclick = check

function check (e) {
    var target = (e && e.target) || (event && event.srcElement)

    // actionToggle(userMenu, userMenuDiv, target, 'invisible') // <-- THis one Works

    actionToggle(navMenu, navMenuDiv, target, 'hidden') // This one does not!!!!!

}

function actionToggle (actionElm, contentElm, target, toggleClass) {
    if (!checkParent(target, contentElm)) {
        // click NOT on the menu
        if (checkParent(target, actionElm)) {
            // click on the link
            if (contentElm.classList.contains(toggleClass)) {
                contentElm.classList.remove(toggleClass)
            } else {contentElm.classList.add(toggleClass)}
        } else {
            // click both outside link and outside menu, hide menu
            contentElm.classList.add(toggleClass)
        }
    }
}

function checkParent (t, elm) {
    while (t.parentNode) {
        if (t == elm) {return true}
        t = t.parentNode
    }
    return false
}
